import { BaseTheme } from "./BaseTheme";
import { FontSizeEnum, FontTypeEnum } from "../FontText/FontTextEnums";
import { IFontSize, IFontType, ITheme } from "./ThemeTypes";
import { ThemeColorEnum } from "./ThemeEnums";

export const themeColorTriplet = (
  color: ThemeColorEnum | undefined,
  theme: ITheme,
): string | null => {
  switch (color) {
    case ThemeColorEnum.CUSTOM_YELLOW:
      return theme.base.custom_colors.yellow;
    case ThemeColorEnum.CUSTOM_GREEN:
      return theme.base.custom_colors.green;
    case ThemeColorEnum.CUSTOM_BLUE:
      return theme.base.custom_colors.blue;
    case ThemeColorEnum.CUSTOM_RED:
      return theme.base.custom_colors.red;
    case ThemeColorEnum.SURFACE_VARIANT:
      return theme.colors.surface_variant;
    case ThemeColorEnum.ON_SURFACE_VARIANT:
      return theme.colors.on_surface_variant;
    case ThemeColorEnum.SURFACE:
      return theme.colors.surface;
    case ThemeColorEnum.SURFACE_CONTAINER:
      return theme.colors.surface_container;
    case ThemeColorEnum.ON_SECONDARY_CONTAINER:
      return theme.colors.on_secondary_container;
    case ThemeColorEnum.ON_TERTIARY_CONTAINER:
      return theme.colors.on_tertiary_container;
    case ThemeColorEnum.ON_SURFACE:
      return theme.colors.on_surface;
    case ThemeColorEnum.PRIMARY:
      return theme.colors.primary;
    case ThemeColorEnum.ON_PRIMARY:
      return theme.colors.on_primary;
    case ThemeColorEnum.INVERSE_ON_SURFACE:
      return theme.colors.inverse_on_surface;
    case ThemeColorEnum.ERROR:
      return theme.colors.error;
    default:
      return null;
  }
};

export const themeColor = (color: ThemeColorEnum | undefined, theme: ITheme): string | null => {
  const triplet = themeColorTriplet(color, theme);
  return triplet ? `rgb(${triplet})` : null;
};

const themeFontType = (type: FontTypeEnum): IFontType => {
  switch (type) {
    case FontTypeEnum.DISPLAY:
      return BaseTheme.typography.display;
    case FontTypeEnum.HEADLINE:
      return BaseTheme.typography.headline;
    case FontTypeEnum.TITLE:
      return BaseTheme.typography.title;
    case FontTypeEnum.LABEL:
      return BaseTheme.typography.label;
    case FontTypeEnum.BODY:
      return BaseTheme.typography.body;
    default:
      console.error(`Unknown FontTypeEnum: ${type}, defaulting to BODY`);
      return BaseTheme.typography.body;
  }
};

const themeFontSize = (fontType: IFontType, size: FontSizeEnum): IFontSize => {
  switch (size) {
    case FontSizeEnum.LARGE_PROMINENT:
      return fontType.large_prominent;
    case FontSizeEnum.LARGE:
      return fontType.large;
    case FontSizeEnum.MEDIUM:
      return fontType.medium;
    case FontSizeEnum.MEDIUM_PROMINENT:
      return fontType.medium_prominent;
    case FontSizeEnum.SMALL:
      return fontType.small;
    default:
      console.error(`Unknown FontSizeEnum: ${size}, defaulting to MEDIUM`);
      return fontType.medium;
  }
};

export const themeFont = (type: FontTypeEnum, size: FontSizeEnum): IFontSize =>
  themeFontSize(themeFontType(type), size);
